import { get, post, patch, del } from 'src/integracoes/servicos/api/api-pgloader';
import { ISchedule } from '../modelos/ISchedule';
import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';

export const listarShedules = async (empId: string): Promise<IRespostaFuncao<ISchedule[]>> => {
  return await get<IRespostaFuncao<ISchedule[]>>(`api/schedules/empresa/${empId}`);
};

export const criarShedule = async (payload: ISchedule) => {
  return await post<IRespostaFuncao<ISchedule>>(`api/schedule`, payload);
};

export const editarShedule = async (id: string, schedule: Partial<ISchedule>) => {
  return await patch<IRespostaFuncao<ISchedule>>(`api/schedule/${id}`, schedule);
};

export const excluirShedule = async (id: string, userId: string, email: string) => {
  return await del<IRespostaFuncao<ISchedule>>(`api/schedule/${id}`, { data: { userId, email } });
};
